import React from 'react'
import { getFormatedWeb3Address } from '../../utils/helpers';
import { Link } from 'react-router-dom';

const Followers = ({ profileFollowers }) => {
    return (
        <>
            <div className="inner-tab-content inner-tab-content-fowin" style={{ display: "block" }}>
                <div className="fowin-parent">
                    {profileFollowers ? (
                        profileFollowers?.map((item) => {
                            const userData = item?.follower;
                            return (
                                <div className="single-user" key={item?._id}>
                                    <Link to={`/user-profile?id=${item?.follower?._id}`} className="left-user">
                                        <div className="main-profile">
                                            <img
                                                src={userData?.profilePic || "/assets/youtube/1.png"}
                                                alt="profile"
                                                className='img-fluid'
                                            />
                                        </div>
                                        <div className="text">
                                            <h6>{userData?.name}</h6>
                                            <p>{getFormatedWeb3Address(userData?.walletAddress, true)}</p>
                                        </div>
                                    </Link>
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-results">
                            <p>No followers found</p>
                        </div>
                    )}
                </div>
            </div >
        </>
    )
}

export default Followers
